module.exports = __webpack_public_path__ + "img/agent.ff0abf59.svg";